import React from 'react'

import { TtTrayBreaker } from '@23/react'

import { type PropsWithTrayItemChildren } from '../TrayItem'
import { setTrayCardEditing, useTrayCardEditingId } from '../useTrayEditing'
import {
  updateBreakerCard,
  useTrayCard,
  useTrayCardState,
} from '../../../../firebase/hooks/useTray'

interface BreakerCardProps {
  id: string
}

const BreakerCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<BreakerCardProps>) => {
  const card = useTrayCard(id)
  const cardState = useTrayCardState(id)

  const cardBeingEdited = useTrayCardEditingId()
  const isEditing = cardBeingEdited === id

  const onLabelChangeHandler = (value: string) => {
    updateBreakerCard(id, value)
    setTrayCardEditing(null)
  }

  if (card?.type !== 'breaker') return null

  return (
    <TtTrayBreaker
      label={card.label}
      editing={isEditing}
      disabled={cardState === 'done'}
      onTt-change={(e) => onLabelChangeHandler(e.detail.value)}
    >
      {children?.({ canEdit: true })}
    </TtTrayBreaker>
  )
}

export default BreakerCard
